import { render, staticRenderFns } from "./TabContas.vue?vue&type=template&id=003d3b7a&scoped=true&"
import script from "./TabContas.vue?vue&type=script&setup=true&lang=js&"
export * from "./TabContas.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d3b7a",
  null
  
)

export default component.exports